import { tenantPath } from "@/lib/tenant";

const pages = new Set(["/jobs", "/admin/bookings/existing", "/admin/bookings", "/admin/bookings/confirmed",
  "/admin/bookings/create", "/dealer/bookings/create", "/dealer/bookings", "/dealer/plots",
  "/admin/inventory", "/admin/inventory/dashboard", "/admin/finance/vouchers", "/admin/finance/payments",
  "/admin/finance/opening-reconciliation", "/admin/accounting/accounts"]);

export const isExistingUpload = job => /^(legacy|installment)_(preview|refresh|import)$/.test(job?.operation || "");
export const uploadWorkflows = {
  existing_bookings: { title: "Your booking and installment upload jobs", matches: isExistingUpload },
  inventory: { title: "Your inventory upload jobs", path: "/admin/inventory", matches: job => /^inventory_(upload|refresh|import)$/.test(job?.operation || "") },
  payments: { title: "Your payment upload jobs", path: "/admin/finance/payments", matches: job => /^payment_(preview|refresh|import)$/.test(job?.operation || "") },
  banks: { title: "Your bank-account upload jobs", path: "/admin/accounting/accounts", matches: job => /^bank_(parse|preview|import)$/.test(job?.operation || "") },
};
export function handlesUploadPage(location) {
  if (location.pathname?.endsWith("/admin/bookings/existing")) return true;
  const section = new URLSearchParams(location.search).get("upload");
  return !!uploadWorkflows[section]?.path && location.pathname?.endsWith(uploadWorkflows[section].path);
}
export function jobPage(job) {
  const section = Object.keys(uploadWorkflows).find(key => uploadWorkflows[key].path && uploadWorkflows[key].matches(job));
  if (section) return tenantPath(`${uploadWorkflows[section].path}?background_job=${encodeURIComponent(job.id)}&upload=${section}`);
  const fallback = isExistingUpload(job) ? "/admin/bookings/existing" : "/jobs";
  const path = pages.has(job?.origin_path) ? job.origin_path : fallback;
  return tenantPath(`${path}?background_job=${encodeURIComponent(job.id)}`);
}
